import { Component, Input, OnInit } from '@angular/core';
import { ColorClass } from 'shared';
import { CashPaymentStatus } from 'shared';

@Component({
    selector: 'app-cash-payment-status-badge',
    templateUrl: './cash-payment-status-badge.component.html',
    styleUrls: ['./cash-payment-status-badge.component.scss'],
})
export class CashPaymentStatusBadgeComponent implements OnInit {
    @Input() state: CashPaymentStatus;
    public colorClass: ColorClass;
    public CashPaymentStatus = CashPaymentStatus;

    ngOnInit() {
        switch (this.state) {
            case CashPaymentStatus.NonCashPayment:
                this.colorClass = ColorClass.Secondary;
                break;
            case CashPaymentStatus.CashPaymentPendingCollection:
                this.colorClass = ColorClass.Danger;
                break;
            case CashPaymentStatus.CashPaymentCollected:
                this.colorClass = ColorClass.Primary;
                break;
            case CashPaymentStatus.CashPaymentInProgress:
                this.colorClass = ColorClass.Warning;
                break;
            case CashPaymentStatus.CashPaymentCompleted:
                this.colorClass = ColorClass.Success;
                break;
        }
    }
}
